// export const domain = "http://127.0.0.1:8000/api";
// export const domain_dashboard = "http://127.0.0.1:8000/cases/dashboard";
// export const domain_img_evidence = "http://127.0.0.1:8000";


// export const domain = "https://dip.ddc.moph.go.th/forensic_admin_v2/public/api";
// export const domain_dashboard = "https://dip.ddc.moph.go.th/forensic_admin_v2/public/cases/dashboard";
// export const domain_img_evidence = "https://dip.ddc.moph.go.th/forensic_admin_v2/public";

// export const domain = "http://forensic.moph.go.th:8080/api";
// export const domain_dashboard = "http://forensic.moph.go.th:8080/cases/dashboard";
// export const domain_img_evidence = "http://forensic.moph.go.th:8080";

//KSTA
export const domain = "https://forensic-admin.ksta.co/api";
export const domain_dashboard = "https://forensic-admin.ksta.co/cases/dashboard";
export const domain_img_evidence = "https://forensic-admin.ksta.co/";
